























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import AuthModule from '@/store/AuthModule';
import FiltersModule from '@/store/FiltersModule';
import router from '../../../router';
import Support from '@/components/Support.vue';
import { BACKEND_URL } from '@/helpers/constants';
import User from '@/models/User';
import { getUserTokensActivePrescriber } from '@/api/api';
import Subscription from '@/models/Subscription';
import UserToken from '@/models/UserToken';
import moment from 'moment';
import { each } from 'lodash';
import ServicesSelector from './ServicesSelector.vue';

@Component({
    components: {
        Support,
        ServicesSelector
    },
})
export default class NavBar extends Vue {
    supportPopupActive: boolean = false;
    tutoPopup: Boolean = false;
    notificationsPopupActive: boolean = false; // Added state for notification popup
    annualSubscription: boolean = false;
    subscription: Subscription | undefined;
    isMapPluginActive: any | undefined;

    get firstname() {
        return AuthModule.firstname;
    }

    get isRestricted() {
        return AuthModule.isRestricted
    }

    get lastname() {
        return AuthModule.lastname;
    }

    get logo() {
        return AuthModule.logo;
    }


    get photoImage() {
    return AuthModule.photo;
        }

    get backendUrl() {
            return BACKEND_URL;
        }


    get isSubscribed() {
        return AuthModule.isSubscriptionActive;
    }

    get isTrial() {
        return AuthModule.isTrialActive;
    }


    isImmo() {
        return localStorage.getItem('service') == 'immo'
    }

    isFinance() {
        return localStorage.getItem('service') == 'finance'
    }

    isCredit() {
        return localStorage.getItem('service') == 'credit'
    }

    isDataAndLead() {
        return localStorage.getItem('service') == 'lead'
    }

    isAllowed(feature: string) {
        if (AuthModule.isRestricted) {
            const restrictedFeatures = ["prescriberMapSettings", "subscription", "sponsorship", "prescriber-invoices"];
            return !restrictedFeatures.includes(feature);
        }
        return true;
    }

    async logout() {
        await AuthModule.logout();
        this.$router.push({ name: 'login' });
    }

    toggle() {
        FiltersModule.toggleShow();
    }

    created() {
        this.onRoute();
    }

    isHomePrescriber: boolean = false;
    @Watch('$route', { deep: true })
    onRoute() {
        this.isHomePrescriber = this.$route.name === 'homePrescriber';
    }

}
